import React, { useRef } from "react";
import { type BookkeepingCurrency } from "./hooks";
import NumberInput from "components/NumberInput";
import { useValidate } from "formvalidation/hooks";
import { PhopshorArrowRight } from "components/Atoms/PhosphorIcon";

interface Props {
  bookkeepingCurrency: BookkeepingCurrency
  validatorKey?: string
  error?: boolean
}

const ExchangeRatePicker = (props: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const validation = useValidate({
    key: props.validatorKey,
    title: RESX.Financial.ExchangeRate,
    value: props.bookkeepingCurrency.exchangeRate,
    validate: async (value) => {
      return value != null && value > 0;
    },
    ref: inputRef,
    legacyError: props.error != null ? {
      error: { hasError: props.error },
      setError: () => { }
    } : undefined
  })

  return <div className="flex align-center">
    <div className="margin-right-small">
      <NumberInput
        innerRef={inputRef}
        value={props.bookkeepingCurrency.exchangeRate}
        width={120}
        canBeNegative={false}
        decimalPoints={6}
        onChanged={newValue => { props.bookkeepingCurrency.onExchangeRateChange(newValue.value); }}
        error={validation.error.hasError}
      />
    </div>
    <div className="grow1">
      <button
        type="button"
        className="button-new tertiary"
        onClick={props.bookkeepingCurrency.refreshExchangeRate}
      >
        {RESX.Buttons.btnRefresh}
      </button>
    </div>

    <div className="padding huge_text">
      {props.bookkeepingCurrency.bookkeeping?.baseCurrency.toUpperCase()}
    </div>
    <div style={{ height: 18 }}>
      <PhopshorArrowRight iconColor="gray" />
    </div>
    <div className="padding huge_text">
      {props.bookkeepingCurrency.currency?.toUpperCase()}
    </div>
  </div>;
};

interface ExchangeRateDetailsProps {
  value: number
  fromCurrency: server.dto.Currencies
  toCurrency: server.dto.Currencies
}

export const ExchangeRateDetails = (props: ExchangeRateDetailsProps) => {
  return <div className="gap flex align-center">
    <div>
      {props.value}
    </div>
    <div className="huge_text">
      {props.fromCurrency.toUpperCase()}
    </div>
    <div style={{ height: 18 }}>
      <PhopshorArrowRight iconColor="gray" />
    </div>
    <div className="huge_text">
      {props.toCurrency.toUpperCase()}
    </div>
  </div>
}

export default ExchangeRatePicker;